//
// LabelValuePickResultDetails.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../lib";
import "@sas-dvr/ltjs-commons/pickResults/PickResultDetails";
import "@sas-dvr/ltjs-commons/models/data/DataValue";
import "./data/Role";

var LabelValuePickResultDetails = createModule("gtl::LabelValuePickResultDetails", ["commons::PickResultDetails"], ClosetObject, [
    ,
    ,
    ,
    {
        isTruncated: 2,
        roles: [1],
        formattedValue: 7,
        isHyperlink: 2,
        label: 7,
        value: 1,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default LabelValuePickResultDetails;
